import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { LanguageService } from '@hazmatsuite-next/ui';
import { ReloadService } from '../../../services/reload.service';
import { EnumPackageType, CompositePackagingModel, OverPackagingModel, SinglePackagingModel, Packages, PackagingModel, EasyDgdService } from '@hazmatsuite-next/easydgd-lib';
import { addOverpack, assignOverpack, createTempPackage, duplicateCompositePackage, duplicateSinglePackage, removeCompositePackage, removeOverpack, removeSinglePackage, setTempOverpack, updateOverpack } from '../../../store/package-list.actions';
import * as uuid from 'uuid';

@Component({
  selector: 'easydgd-packing-list-treeview',
  templateUrl: './packing-list-treeview.component.html',
  styleUrls: ['./packing-list-treeview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackingListTreeviewComponent {
  @Output() openEditor = new EventEmitter<{ packageType: EnumPackageType, title: string }>();

  public compositePackagingItems: CompositePackagingModel[] = [];
  public overPackagingItems: OverPackagingModel[] = [];
  public singlePackagingItems: SinglePackagingModel[] = [];

  public packageTypes = EnumPackageType;
  public packageCount = 0;
  public overpackToEdit?: OverPackagingModel = undefined;

  public validationResource$: Observable<any> = this.languageService.translations$.pipe(
    map(translations => translations['ValidationResource']));

  public packingListResource$: Observable<any> = this.languageService.translations$.pipe(
    map(translations => translations['PackingListResource']));


  constructor(
    private languageService: LanguageService,
    private store: Store<{ packageList: { packages: Packages, tempPackage: PackagingModel } }>,
    private reloadService: ReloadService,
    private easyDgdService: EasyDgdService
  ) { }

  public items$ = this.store.select(state => state.packageList).pipe(
    tap((state) => {
      if ((state.packages?.CompositePackagingItems?.length &&
        state.packages?.CompositePackagingItems.some(item => item.Items.some(itm => itm.DangerousGoodId && !itm.DangerousGood)) ||
        state.packages?.SinglePackagingItems?.length && state.packages.SinglePackagingItems.some(item => item.DangerousGoodId && !item.DangerousGood))
      ) {
        this.reloadService.reloadCompositePackagingDangerousGoods(state.packages?.CompositePackagingItems || [], this.easyDgdService.getTransportMode());
        this.reloadService.reloadSinglePackagingDangerousGoods(state.packages?.SinglePackagingItems || [], this.easyDgdService.getTransportMode());
        return;
      }
      this.compositePackagingItems = state.packages?.CompositePackagingItems
      this.overPackagingItems = state.packages?.OverpackPackagingItems || [];
      this.singlePackagingItems = state.packages?.SinglePackagingItems || [];

      this.packageCount = this.compositePackagingItems.length + this.singlePackagingItems.length + this.overPackagingItems.length;
    })
  );

  public editOverpack(pkg: OverPackagingModel) {
    this.store.dispatch(updateOverpack({ pkg: pkg }));
  }

  public editOverpackItem(data: { packageId: string, pkg: OverPackagingModel, isEdit: boolean }) {
    if (!data) {
      return;
    }

    if (data.isEdit) {
      this.store.dispatch(assignOverpack({ packageId: data.packageId, overpackId: data.pkg.Id }));
    } else {
      this.store.dispatch(addOverpack({ packageId: data.packageId, pkg: data.pkg }));
    }
  }

  public editPackage(item: PackagingModel, title: string) {
    this.store.dispatch(createTempPackage({ tempPackage: item }));
    this.openEditor.next({ packageType: item.PackageType, title: title })
  }

  public removeOverpack(pkg: OverPackagingModel) {
    this.store.dispatch(removeOverpack({ pkg: pkg }));
  }

  public removeSinglePackage(pkg: SinglePackagingModel) {
    this.store.dispatch(removeSinglePackage({ id: pkg.Id }));
  }

  public removeCompositePackage(pkg: CompositePackagingModel) {
    this.store.dispatch(removeCompositePackage({ id: pkg.Id }));
  }

  // public duplicateOverpack(pkg: OverPackagingModel) {
  //   this.store.dispatch(duplicateO({ pkg: pkg }));
  // }

  public copyCompositePackage(pkg: CompositePackagingModel) {
    this.store.dispatch(duplicateCompositePackage({ pkg: pkg }));
  }

  public copySinglePackage(pkg: SinglePackagingModel): void {
    this.store.dispatch(duplicateSinglePackage({
      pkg: {
        ...pkg,
        InternalId: uuid.v4()
      }
    }));
  }

  public assignOverpack(data: { packageId: string, overpackId: string }): void {
    this.store.dispatch(assignOverpack({ packageId: data.packageId, overpackId: data.overpackId }));
  }

}
